import React, { useEffect } from 'react'
import $ from 'jquery'
import {
  findObjectByTestName,
  getFeedbackByTIN,
  getFeedBackDivIdByTIN,
  getTestNameFromIframe,
  setWaitingId,
  setFeedbackId,
  getPollingValue
} from '../Common'

export const VsMultiple = ({ data, getPollingData }) => {
  useEffect(() => {
    // This function will be called when the component mounts
    const handleComponentMount = () => {
      let testName = getTestNameFromIframe()
      setWaitingId(testName)
      setFeedbackId(testName)

      //The following will restore feedback after delivered if user switches pages and returns
      let thisComponentObj = findObjectByTestName('speedingExcuse')
      if (thisComponentObj !== null && thisComponentObj !== undefined) {
        let TIN = Object.keys(thisComponentObj)[0]
        let feedback = getFeedbackByTIN(thisComponentObj, TIN)
        let feedBackDivId = getFeedBackDivIdByTIN(thisComponentObj, TIN)
        if (feedback) $(feedBackDivId).html(feedback) //if null don't overwrite what's there
      }
    }
    handleComponentMount()
  }, []) // The empty dependency array ensures this runs only once when the component mounts
  return (
    <div style={{ height: '100vh', overflowY: 'auto', paddingRight: '20px' }}>
      <div style={{ marginTop: '130px', marginLeft: '20px', fontSize: '22px' }}>
        These tests compare multiple choice testing with conversational testing.
      </div>{' '}
      <br></br>
      <div
        style={{
          position: 'relative',
          marginLeft: '40px',
          fontSize: '18px',
          color: 'slateblue'
        }}
      >
        <i>
          Use a cell phone, or a PC with mic and speakers (or a headset). At the
          end of each sample you will be asked for your email address so a score
          report can be emailed to you. The report will reach you within a
          minute or two of test completion.
        </i>
      </div>
      <br></br>
      <br></br>
      <ol className='sampleTests-list'>
        <li>
          <a
            href='https://take.tellmethis.info/?TIN=041259078&testName=Montage_4&accountId=MFpaLrYQL&mode=C&clientLogo=true'
            //href='https://tmt-taker.herokuapp.com/?TIN=041259078&testName=Montage_4&accountId=MFpaLrYQL&mode=C&clientLogo=true'
            target='_blank'
          >
            DoTell Conversational Test Demo
          </a>
          &nbsp;&ndash; An assortment of conversational test items to pique your
          interest.
        </li>
        <li>
          <a
            href='https://take.tellmethis.info/?TIN=027916442&testName=CF%20Audio%20MC%203&accountId=MFpaLrYQL&mode=C&clientLogo=true'
            //href='https://tmt-taker.herokuapp.com/?TIN=027916442&testName=CF%20Audio%20MC%203&accountId=MFpaLrYQL&mode=C&clientLogo=true'          
            target='_blank'
          >
            Conversational vs. Multiple Choice Testing
          </a>
          &nbsp;&ndash; Experience the value-add of conversational test items
          instead of multiple choice items.
        </li>
      </ol>
      <div className='iFrameContainer'>
        <div className='abox' style={{ minWidth: '200px' }}></div>
        <div className='abox' style={{ marginLeft: '30px' }}>
          <div id='cardCaption'>
            Caught speeding <strong> ! ! !</strong>
          </div>
          <iframe
            src='https://take.tellmethis.info/?TIN=037483178&testName=speedingExcuse&accountId=MFpaLrYQL&mode=C&clientLogo=true&clr=black&t0=2288aa&t1=d1e0e3&extUserId=00000&extUserEmail=00000&msg=%253Cdiv%253E%253Cbr%253E%253C%2Fdiv%253ECan%2520you%2520talk%2520your%2520way%26nbsp%3B%253Cdiv%253Eout%2520of%2520a%2520speeding%2520ticket%3F%253Cdiv%253E%253Cbr%253E%253C%2Fdiv%253E%253Cdiv%253EClick%2520here%2520and%2520see%2520how%26nbsp%3B%253C%2Fdiv%253E%253Cdiv%253Ewell%2520you%2520score!%253C%2Fdiv%253E%253C%2Fdiv%253E'
            //src='https://tmt-taker.herokuapp.com/?TIN=037483178&testName=speedingExcuse&accountId=MFpaLrYQL&mode=C&clientLogo=true&clr=black&t0=2288aa&t1=d1e0e3&extUserId=00000&extUserEmail=00000&msg=%253Cdiv%253E%253Cbr%253E%253C%2Fdiv%253ECan%2520you%2520talk%2520your%2520way%26nbsp%3B%253Cdiv%253Eout%2520of%2520a%2520speeding%2520ticket%3F%253Cdiv%253E%253Cbr%253E%253C%2Fdiv%253E%253Cdiv%253EClick%2520here%2520and%2520see%2520how%26nbsp%3B%253C%2Fdiv%253E%253Cdiv%253Ewell%2520you%2520score!%253C%2Fdiv%253E%253C%2Fdiv%253E'
            width='314'
            height='217'  
            frameBorder='0'
            allow='microphone'
            // style="border-radius: 12px;"
            style={{ borderRadius: '12px' }}
          ></iframe>
        </div>
        <div id='feedbackBox' className='abox'>
          <div
            id='feedback-speedingExcuse' //feedback div needs testname in id
            style={{
              padding: '12px',
              justifyContent: 'left',
              alignItems: 'left',
              /* height: '200px', */
              width: '100%',
              overflow: 'auto',
              margin: 'auto',
              border: 'none' //'inset thin gray'
            }}
          ></div>
          <span
            className='waitingGif'
            id='waitingGif-speedingExcuse'
            style={{
              visibility: 'hidden',
              position: 'relative',
              zIndex: 10
            }}
          >
            <img src='waiting.gif' width='50'></img>
          </span>
        </div>
      </div>
    </div>
  )
}
